<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">Teaching in Tongren, China</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#introduction">Introduction</a></li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-1-guizhou-province">Chapter 1: Guizhou Province</a></li>
<li id="toc-li-7"><a href="#/text/ch007#chapter-2-the-city-of-tongren">Chapter 2: The City of
                    Tongren</a>
<ol class="toc">
<li id="toc-li-8"><a href="#/text/ch007#introduction-1">Introduction</a></li>
<li id="toc-li-9"><a href="#/text/ch007#transport">2.1: Transport</a>
</li>
<li id="toc-li-14"><a href="#/text/ch007#walking-street">2.2: Walking Street</a></li>
<li id="toc-li-15"><a href="#/text/ch007#qingshui-dadao">2.3: Qingshui Dadao</a></li>
<li id="toc-li-16"><a href="#/text/ch007#jin-jing-guangcheng">2.4: Jin Jing Guangcheng</a></li>
<li id="toc-li-17"><a href="#/text/ch007#old-tongren">2.5: Old Tongren</a></li>
</ol>
</li>
<li id="toc-li-18"><a href="#/text/ch008#chapter-3-accommodation">Chapter 3: Accommodation</a>
<ol class="toc">
<li id="toc-li-19"><a href="#/text/ch008#arrival">3.1: Arrival</a></li>
<li id="toc-li-20"><a href="#/text/ch008#my-first-apartment">3.2: My First Apartment</a></li>
<li id="toc-li-21"><a href="#/text/ch008#my-second-apartment">3.3: My Second Apartment</a></li>
<li id="toc-li-22"><a href="#/text/ch008#the-backyard">3.4: The Backyard</a></li>
<li id="toc-li-23"><a href="#/text/ch008#how-i-blew-a-fuse">3.5: How I Blew a Fuse</a></li>
<li id="toc-li-24"><a href="#/text/ch008#other-apartments">3.6: Other Apartments</a>
</li>
<li id="toc-li-27"><a href="#/text/ch008#the-final-year">3.7: The Final Year</a></li>
</ol>
</li>
<li id="toc-li-28"><span href="#/text/ch009#chapter-4-the-jinjiang-river" title="Link target outside of Sample">Chapter 4: The Jinjiang River</span>
<ol class="toc">
<li id="toc-li-29"><span href="#/text/ch009#around-the-river" title="Link target outside of Sample">4.1: Around the River</span></li>
<li id="toc-li-30"><span href="#/text/ch009#on-the-river" title="Link target outside of Sample">4.2: On the River</span>
</li>
<li id="toc-li-33"><span href="#/text/ch009#in-the-river" title="Link target outside of Sample">4.3: In the River</span></li>
</ol>
</li>
<li id="toc-li-34"><span href="#/text/ch010#chapter-5-mountains" title="Link target outside of Sample">Chapter 5: Mountains</span>
<ol class="toc">
<li id="toc-li-35"><span href="#/text/ch010#introduction-2" title="Link target outside of Sample">Introduction</span></li>
<li id="toc-li-36"><span href="#/text/ch010#wen-bi-feng" title="Link target outside of Sample">5.1: Wen Bi Feng</span>
</li>
<li id="toc-li-40"><span href="#/text/ch010#jia-nian-shan" title="Link target outside of Sample">5.2: Jia Nian Shan</span>
</li>
<li id="toc-li-43"><span href="#/text/ch010#xiao-shan" title="Link target outside of Sample">5.3: Xiao Shan</span></li>
<li id="toc-li-44"><span href="#/text/ch010#railway-hill" title="Link target outside of Sample">5.4: Railway hill</span></li>
<li id="toc-li-45"><span href="#/text/ch010#fan-jing-shan" title="Link target outside of Sample">5.5: Fan Jing Shan</span>
</li>
<li id="toc-li-52"><span href="#/text/ch010#on-location" title="Link target outside of Sample">5.6: On Location</span>
</li>
</ol>
</li>
<li id="toc-li-56"><span href="#/text/ch011#chapter-6-tongren-university" title="Link target outside of Sample">Chapter 6: Tongren University</span>
<ol class="toc">
<li id="toc-li-57"><span href="#/text/ch011#introduction-5" title="Link target outside of Sample">Introduction</span></li>
<li id="toc-li-58"><span href="#/text/ch011#tongren-university-campus" title="Link target outside of Sample">6.1: Tongren University
                            campus</span></li>
<li id="toc-li-59"><span href="#/text/ch011#the-foreign-affairs-office" title="Link target outside of Sample">6.2: The Foreign Affairs
                            Office</span>
</li>
<li id="toc-li-65"><span href="#/text/ch011#health-checks" title="Link target outside of Sample">6.3: Health Checks</span>
</li>
<li id="toc-li-67"><span href="#/text/ch011#how-was-your-holiday" title="Link target outside of Sample">6.4: How Was Your Holiday?</span>
</li>
<li id="toc-li-68"><span href="#/text/ch011#attitudes-to-laowai" title="Link target outside of Sample">6.5: Attitudes to
                            <em>Laowai</em></span></li>
<li id="toc-li-69"><span href="#/text/ch011#athletics-carnivals" title="Link target outside of Sample">6.6: Athletics Carnivals</span>
</li>
</ol>
</li>
<li id="toc-li-72"><span href="#/text/ch012#chapter-7-teaching" title="Link target outside of Sample">Chapter 7: Teaching</span>
<ol class="toc">
<li id="toc-li-73"><span href="#/text/ch012#introduction-6" title="Link target outside of Sample">Introduction</span></li>
<li id="toc-li-74"><span href="#/text/ch012#classes-and-courses" title="Link target outside of Sample">7.1: Classes and Courses</span>
</li>
<li id="toc-li-84"><span href="#/text/ch012#dreams" title="Link target outside of Sample">7.2: Dreams</span></li>
<li id="toc-li-85"><span href="#/text/ch012#english-festival" title="Link target outside of Sample">7.3: English Festival</span></li>
<li id="toc-li-86"><span href="#/text/ch012#english-contests" title="Link target outside of Sample">7.4: English Contests</span>
</li>
<li id="toc-li-89"><span href="#/text/ch012#examinations" title="Link target outside of Sample">7.5: Examinations</span>
</li>
<li id="toc-li-95"><span href="#/text/ch012#art" title="Link target outside of Sample">7.6: Art</span></li>
</ol>
</li>
<li id="toc-li-96"><span href="#/text/ch013#chapter-8-the-students" title="Link target outside of Sample">Chapter 8: The Students</span>
<ol class="toc">
<li id="toc-li-97"><span href="#/text/ch013#introduction-9" title="Link target outside of Sample">Introduction</span></li>
<li id="toc-li-98"><span href="#/text/ch013#names" title="Link target outside of Sample">8.1: Names</span></li>
<li id="toc-li-99"><span href="#/text/ch013#bai-ma-dong" title="Link target outside of Sample">8.2: Bai Ma Dong</span></li>
<li id="toc-li-100"><span href="#/text/ch013#cao-ping-yuan" title="Link target outside of Sample">8.3: Cao Ping Yuan</span></li>
<li id="toc-li-101"><span href="#/text/ch013#jiu-long-dong" title="Link target outside of Sample">8.4: Jiu Long Dong</span></li>
<li id="toc-li-102"><span href="#/text/ch013#a-great-weekend" title="Link target outside of Sample">8.5: A Great Weekend</span></li>
<li id="toc-li-103"><span href="#/text/ch013#more-class-picnics" title="Link target outside of Sample">8.6: More Class Picnics</span>
</li>
<li id="toc-li-107"><span href="#/text/ch013#contests" title="Link target outside of Sample">8.7: Contests</span></li>
</ol>
</li>
<li id="toc-li-108"><span href="#/text/ch014#chapter-9-outside-tongren" title="Link target outside of Sample">Chapter 9: Outside Tongren</span>
<ol class="toc">
<li id="toc-li-109"><span href="#/text/ch014#introduction-10" title="Link target outside of Sample">Introduction</span></li>
<li id="toc-li-110"><span href="#/text/ch014#ielts-preparation" title="Link target outside of Sample">9.1: IELTS Preparation</span></li>
<li id="toc-li-111"><span href="#/text/ch014#wan-shan" title="Link target outside of Sample">9.2: Wan Shan</span></li>
<li id="toc-li-112"><span href="#/text/ch014#mai-cun" title="Link target outside of Sample">9.3: Mai Cun</span></li>
<li id="toc-li-113"><span href="#/text/ch014#kaili" title="Link target outside of Sample">9.4: Kaili</span></li>
<li id="toc-li-114"><span href="#/text/ch014#guiyang" title="Link target outside of Sample">9.5: Guiyang</span></li>
<li id="toc-li-115"><span href="#/text/ch014#the-cost-of-a-signature" title="Link target outside of Sample">9.6: The Cost of a
                            Signature</span></li>
<li id="toc-li-116"><span href="#/text/ch014#sinan" title="Link target outside of Sample">9.7: Sinan</span>
</li>
<li id="toc-li-120"><span href="#/text/ch014#shiqian" title="Link target outside of Sample">9.8: Shiqian</span>
</li>
<li id="toc-li-124"><span href="#/text/ch014#zhen-yuan" title="Link target outside of Sample">9.9: Zhen Yuan</span></li>
<li id="toc-li-125"><span href="#/text/ch014#other-towns" title="Link target outside of Sample">9.10: Other Towns</span>
</li>
</ol>
</li>
<li id="toc-li-131"><span href="#/text/ch015#chapter-10-celebrations" title="Link target outside of Sample">Chapter 10: Celebrations</span>
<ol class="toc">
<li id="toc-li-132"><span href="#/text/ch015#christmas" title="Link target outside of Sample">10.1: Christmas</span>
</li>
<li id="toc-li-135"><span href="#/text/ch015#lantern-festival" title="Link target outside of Sample">10.2: Lantern Festival</span></li>
<li id="toc-li-136"><span href="#/text/ch015#qing-ming" title="Link target outside of Sample">10.3: Qing Ming</span></li>
<li id="toc-li-137"><span href="#/text/ch015#duan-wu-jie" title="Link target outside of Sample">10.4: Duan Wu Jie</span></li>
<li id="toc-li-138"><span href="#/text/ch015#national-day" title="Link target outside of Sample">10.5: National Day</span></li>
<li id="toc-li-139"><span href="#/text/ch015#weddings" title="Link target outside of Sample">10.6: Weddings</span>
</li>
<li id="toc-li-142"><span href="#/text/ch015#concerts" title="Link target outside of Sample">10.7: Concerts</span>
</li>
<li id="toc-li-145"><span href="#/text/ch015#meals" title="Link target outside of Sample">10.8: Meals</span>
</li>
</ol>
</li>
<li id="toc-li-149"><span href="#/text/ch016#chapter-11-daily-living" title="Link target outside of Sample">Chapter 11: Daily Living</span>
<ol class="toc">
<li id="toc-li-150"><span href="#/text/ch016#introduction-11" title="Link target outside of Sample">Introduction</span></li>
<li id="toc-li-151"><span href="#/text/ch016#conversations" title="Link target outside of Sample">11.1: Conversations</span></li>
<li id="toc-li-152"><span href="#/text/ch016#cesuo" title="Link target outside of Sample">11.2: Cesuo</span></li>
<li id="toc-li-153"><span href="#/text/ch016#a-circus-came-to-town" title="Link target outside of Sample">11.3: A Circus Came to Town</span>
</li>
<li id="toc-li-154"><span href="#/text/ch016#no-sex-please-were" title="Link target outside of Sample">11.4: No Sex, Please, We’re…</span>
</li>
<li id="toc-li-155"><span href="#/text/ch016#summer-animals" title="Link target outside of Sample">11.5: Summer Animals</span></li>
<li id="toc-li-156"><span href="#/text/ch016#australian-experience" title="Link target outside of Sample">11.6: Australian Experience</span>
</li>
<li id="toc-li-157"><span href="#/text/ch016#city-changes" title="Link target outside of Sample">11.7: City Changes</span></li>
<li id="toc-li-158"><span href="#/text/ch016#visitors" title="Link target outside of Sample">11.8: Visitors</span></li>
<li id="toc-li-159"><span href="#/text/ch016#accidents" title="Link target outside of Sample">11.9: Accidents</span></li>
<li id="toc-li-160"><span href="#/text/ch016#weevils" title="Link target outside of Sample">11.10: Weevils</span></li>
<li id="toc-li-161"><span href="#/text/ch016#exercise" title="Link target outside of Sample">11.11: Exercise</span></li>
</ol>
</li>
<li id="toc-li-162"><span href="#/text/ch017#chapter-12-farewells" title="Link target outside of Sample">Chapter 12: Farewells</span>
<ol class="toc">
<li id="toc-li-163"><span href="#/text/ch017#introduction-12" title="Link target outside of Sample">Introduction</span></li>
<li id="toc-li-164"><span href="#/text/ch017#farewells-to-greg" title="Link target outside of Sample">12.1: Farewells to Greg</span>
</li>
<li id="toc-li-167"><span href="#/text/ch017#farewells-to-the-americans" title="Link target outside of Sample">12.2: Farewells to the
                            Americans</span></li>
<li id="toc-li-168"><span href="#/text/ch017#graduations" title="Link target outside of Sample">12.3: Graduations</span>
</li>
<li id="toc-li-171"><span href="#/text/ch017#my-farewells" title="Link target outside of Sample">12.4: My Farewells</span></li>
<li id="toc-li-172"><span href="#/text/ch017#conclusion" title="Link target outside of Sample">Conclusion</span></li>
</ol>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?146dd4e7